
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DashboardStats extends Vue {
  @Prop({ required: true }) heading!: string; // Label Id für Überschrift
  @Prop({ required: false, default: null }) value!: any; // Stat-Wert
  @Prop({ required: false, default: null }) formatter?: (value: any) => string; // Formatter-Funktion, optional
}
